import type {MembershipApiModel} from '../../../../api/membership';

import {inviteStore} from '../../../../api/invite';
import {membershipStore} from '../../../../api/membership';
import {ResendInviteStrategy} from './ResendInviteStrategy';

export class ResendProposedMembershipStrategy extends ResendInviteStrategy {
  constructor(private readonly membership: MembershipApiModel) {
    super();
  }

  async resendInvite() {
    const {course_id, program_id} = this.membership;

    await membershipStore.coach.delete(this.membership);

    if (course_id) {
      await inviteStore.sendToCourse({
        course_id: course_id,
        message: this.membership.invite_data?.message ?? undefined,
        program_id: program_id!,
        recipients: [
          {
            email: this.membership.invite_data?.email ?? undefined,
            user_id: this.membership.user_id ?? undefined,
          },
        ],
      });
    } else if (program_id) {
      await inviteStore.sendToProgram({
        program_id,
        recipients: [
          {
            user_id: this.membership.user_id,
          },
        ],
      });
    }
  }
}
